/*
 * @Author: Daokai Huo
 * @Date: 2021-09-26 17:39:46
 * @LastEditTime: 2021-09-26 17:40:46
 * @Description:
 */
import IonButton from './src/ion-button.vue';

IonButton.install = function install(_vue) {
  _vue.component(IonButton.name, IonButton);
};
export default IonButton;
